export const response = {
    "All": {
        "focus_area": [
            {
                "response": [
                    "Pertamina's focus area is on energy security, reliability, and sustainability. The company aims to achieve net zero emissions by 2060 and is committed to developing new and renewable energy sources, such as geothermal, biofuel, and green hydrogen. Additionally, Pertamina focuses on maximizing its legacy businesses, including oil and gas production, refining, and petrochemicals, while also investing in low-carbon technologies and energy transition initiatives. The company's main focus areas include building low-carbon businesses, maximizing legacy businesses, and expanding infrastructure and services."
                ],
                "timestamp": "2025-01-07T13:49:16.920643"
            }
        ],
        "analyst_report": [
            {
                "response": [
                    "No relevant information available."
                ],
                "timestamp": "2025-01-07T13:49:23.117100"
            }
        ],
        "market_landscape": [
            {
                "response": [
                    "**Sustainability drivers:​** Indonesia’s net-zero target by 2060 drives renewable energy growth, incentivizing local firms like Pertamina to align with global clean energy trends.",
                   "**Innovation outlook:** Indonesia offers fiscal incentives for renewable energy, such as tax holidays and import duty exemptions, and plans to implement a carbon tax to accelerate decarbonization.",
                   "**Emerging trends:** Global demand for green hydrogen and SAF is rising, with Singapore and Malaysia emerging as clean energy trade hubs",
                   "**Customer Behavior: ​** International Demand: Japan and South Korea are key hydrogen markets.​ Domestic Impact: Advances Indonesia's renewable energy goals"
                ],
                "timestamp": "2025-01-07T13:49:35.285144"
            }
        ],
        "industry_regulation": {
            "metadata": [
                {
                    "title": "Biodiesel Mandate Increase",
                    "description": "Indonesia plans to increase the biodiesel mandate from 35% to 40% (B40) starting January 1, 2025. Biodiesel Mandate in Indonesia is part of the government’s initiative to reduce dependence on fossil fuels, promote renewable energy sources, and curb greenhouse gas emissions.",
                    "source_name": "Reuters",
                    "sentiment_flag": ""
                },
                {
                    "title": "Carbon Tax",
                    "description": "Indonesia plans to implement a carbon tax to accelerate decarbonization efforts",
                    "source_name": "jakarta globe",
                    "sentiment_flag": ""
                }
            ]
        },
        "industry_benchmark": [
            {
                "response": [
                    "Pertamina's corporate customer retention rate is 85%, higher than the regional average of 78%",
                   "Pertamina’s revenue grew by 12% in 2023, while the industry average for oil and gas companies in the region was 8%"
                ],
                "timestamp": "2025-01-07T13:49:35.285144"
            }
        ],
        "competitive_analysis": {
            "metadata": [
                {
                    "title": "Expansion into Renewable Energy",
                    "description": "Medco Energi has been diversifying its portfolio by investing in renewable energy projects, including geothermal and solar power. This strategic shift aligns with global energy trends and Indonesia's commitment to reducing carbon emissions",
                    "sentiment_flag": "",
                    "source_name": "globaldata.com",
                },
                {
                    "title": "Enhanced Exploration and Production (E&P) Activities",
                    "description": "PetroChina has been actively involved in E&P activities within Indonesia, focusing on increasing its upstream oil and gas production. This approach has enabled them to strengthen their market position domestically.",
                    "source_name": "globaldata.com",
                    "sentiment_flag": ""
                },
                {
                    "title": "Technological Advancements in Deepwater Exploration",
                    "description": "Petrobras has invested heavily in deepwater exploration technologies, allowing them to access and produce oil from offshore reserves more efficiently. This technological edge has positioned them as a leader in offshore oil production.",
                    "source_name": "craft",
                    "sentiment_flag": ""
                }
            ]
        },
        "geopolitics": [
            {
                "response": [
                    "**Geopolitical tensions:​ **Middle East and Russia-Ukraine war: Conflicts globally have put pressure on global crude oil prices and have influenced exchange rates and the Indonesia Crude Oil Price (ICP).",
                   "**International Expansion and Partnerships: ** ​Pertamina is expanding globally by forming strategic partnerships in Africa, including in Kenya and Tanzania​",
                ],
                "timestamp": "2025-01-07T13:49:35.285144"
            }
        ],
        "early_warning": [
            {
                "response": [
                    "No relevant information available regarding the early warning of the company."
                ],
                "timestamp": "2025-01-07T13:49:38.818126"
            }
        ],
        "signals":{
     "metadata":[
         {
            "title":"",
            "description":"Competitive Advantage for Pertamina: Established infrastructure in geothermal energy and robust governmental support give Pertamina an edge over competitors in green hydrogen production.​",
            "source_name":"",
            "sentiment_flag":""
         },
         {
            "title":"",
            "description":"Advise Pertamina on structuring projects that maximize incentives, ensuring cost efficiency and compliance​",
            "source_name":"",
            "sentiment_flag":""
         },
         {
            "title":"",
            "description":"BNI can strengthen Pertamina’s appeal by financing capacity-building projects that enhance supply reliability​",
            "source_name":"",
            "sentiment_flag":""
         },
         {
            "title":"",
            "description":"BNI can act as a local partner with in-depth market knowledge to support Pertamina in staying ahead from the competition​​",
            "source_name":"",
            "sentiment_flag":""
         },
     ]
  },
        "chatbot_query": [
            {
                "response": {
                    "query": "Tell me about Pertamina company in 5 lines",
                    "response": [
                        "Pertamina is a leading company in the energy transition, committed to supporting the Net Zero Emission 2060 target.",
                        "Pertamina achieved its highest-ever net profit in 2022, reaching USD3.81 billion.",
                        "The company's revenue also surged by 48% to USD84.89 billion.",
                        "Pertamina solidified its position as the only Indonesian company included in the Fortune Global 500, ranking 223rd.",
                        "The company is focused on energy transition, with strategies to develop low-carbon products and reduce emissions."
                    ]
                },
                "timestamp": "2025-01-07T13:51:22.005415"
            }
        ]
    },

    "PTPN": {
        "focus_area": [
            {
                "response": [
                    "The focus area of the company, PT Perkebunan Nusantara III (Persero), encompasses several key strategies, including:",
                    "1. **Portfolio Optimization & Operational Excellence**: Enhancing productivity, efficiency, and sustainability in operational management.",
                    "2. **Commercial Excellence & Downstream Expansion**: Investing in priority downstream businesses, such as cooking oil and green diesel, and expanding retail business and customer footprints.",
                    "3. **Asset Optimization & Strategic Partnerships**: Restructuring subsidiaries, strengthening holding governance, and developing strategic partnerships to support business growth.",
                    "4. **Capability Development & Culture**: Developing talents with technical and managerial capabilities, nurturing a new culture, and enhancing system and technology to support business operations.",
                    "5. **System & Technology Enhancement**: Leveraging digitalization and technology for operations and business, integrating sales and marketing functions, and expanding into new markets.",
                    "These focus areas aim to drive the company's growth, improve its financial position, and enhance its competitiveness in the plantation industry."
                ],
                "timestamp": "2025-01-07T13:52:22.761704"
            }
        ],
        "analyst_report": [
            {
                "response": [
                    "The analyst report of the company, PT Perkebunan Nusantara III (Persero), highlights the company's performance in 2023. The report discusses the company's financial and operational performance, risk management, and corporate governance.",
                    "The company's financial performance was considered quite good, although it remained below expectations. The company's revenue and profit increased compared to the previous year, driven by the growth of the manufacturing sector and the construction sector.",
                    "The company's operational performance was also commendable, with the company achieving its targets in terms of production and sales. The company's commitment to good corporate governance practices, enterprise risk management, and business continuity management efforts contributed to its performance.",
                    "The report also highlights the company's risk management efforts, which included identifying, evaluating, and mitigating various risks. The company's risk management system was considered effective in preventing negative impacts on the company's objectives.",
                    "In terms of corporate governance, the company has implemented various measures to ensure transparency and accountability. The company has a Board of Commissioners and a Board of Directors, which oversee the company's management and ensure that it is in line with the company's purpose and objectives.",
                    "The report also discusses the company's outlook for 2024, which is expected to be challenging due to global economic uncertainties. However, the company is confident that it can sustain its growth and achieve its targets through its strategic plans and risk management efforts.",
                    "Overall, the analyst report provides a comprehensive overview of the company's performance in 2023 and its outlook for 2024. It highlights the company's strengths and weaknesses and provides recommendations for improvement."
                ],
                "timestamp": "2025-01-07T13:52:24.913790"
            }
        ],
        "news": [
            {
                "response": [
                    "The company, PTPN III (Persero), has released its annual report for 2023. The report highlights the company's performance, challenges, and strategies for the future. Here is a summary of the key points:",
                    "**Performance:**",
                    "* The company's financial performance was quite good, although it remained below target.",
                    "* Operational performance was also commendable, with the company recording a solid figure of 5.04% (yoy) growth in the fourth quarter of 2023.",
                    "* The company's palm oil production reached 752 thousand tons, with a productivity of 4.20 tons/ha, while tea production was 42.8 thousand tons, with a productivity of 1,814 kg/ha.",
                    "**Challenges:**",
                    "* The company faced challenges such as drought, which affected production, and delays in land preparation and sugarcane planting periods.",
                    "* The company also faced financial obstacles, including the need for further refinement of the draft RKAP 2024 and insufficient liquidity.",
                    "**Strategies:**",
                    "* The company plans to implement multiple strategies, including continuing the Long-Term Corporate Plan (RJPP) for 2020-2024, which includes five major themes: portfolio optimization, operational excellence, commercial excellence, asset optimization, and strategic partnerships.",
                    "* The company will also focus on digitalization, including the development of a Plantation Digitalization Roadmap 2021-2025, to improve operational efficiency and competitiveness.",
                    "* The company will prioritize risk management, including the implementation of a comprehensive risk management system, to mitigate potential risks and ensure business continuity.",
                    "**Corporate Governance:**",
                    "* The company is committed to good corporate governance practices, including transparency, accountability, and responsibility.",
                    "* The company has established a Board of Commissioners and a Board of Directors, which are responsible for overseeing and managing the company's affairs.",
                    "* The company has also established various committees, including an Audit Committee, a Risk Monitoring Committee, and a Nomination and Remuneration Committee, to support the Board of Commissioners and the Board of Directors in their duties.",
                    "**Outlook:**",
                    "* The company is optimistic about its prospects for 2024, with the World Bank predicting Indonesia's economic growth to be 4.9%.",
                    "* The company plans to continue to implement its strategies and prioritize risk management to ensure business continuity and sustainable growth."
                ],
                "timestamp": "2025-01-07T13:52:27.087467"
            }
        ],
        "early_warning": [
            {
                "response": [
                    "No relevant information available regarding the \"early_warning of the company\"."
                ],
                "timestamp": "2025-01-07T13:52:29.153039"
            }
        ],
        "signals": [
            {
                "response": [
                    "The company's signals include:",
                    "1. **Business risks**: The company faces various risks such as geopolitical tensions, global economic slowdown, and commodity price disruptions.",
                    "2. **Operational challenges**: The company experiences operational issues like low fertilizer application, suboptimal maintenance, and delays in land preparation and sugarcane planting.",
                    "3. **Financial performance**: The company's financial performance is affected by factors like decreased liquidity, increased long-term liabilities, and a decline in solvency ratio.",
                    "4. **Market opportunities**: The company has opportunities to develop its CPO and sugar commodities by entering downstream industries and expanding its market potential in countries like India and China.",
                    "5. **Digitalization and technology**: The company recognizes the importance of digitalization and technology in enhancing its operational efficiency, innovation, and competitiveness.",
                    "6. **Corporate governance**: The company prioritizes good corporate governance practices, including risk management, internal control, and compliance with regulations.",
                    "7. **Sustainability and social responsibility**: The company aims to promote sustainable business practices, social responsibility, and environmental conservation.",
                    "These signals indicate the company's efforts to navigate various challenges and opportunities, while prioritizing its long-term sustainability and growth."
                ],
                "timestamp": "2025-01-07T13:52:31.556732"
            }
        ],
        "chatbot_query": [
            {
                "response": {
                    "query": "Tell me about Pertamina company in 5 lines",
                    "response": [
                        "Pertamina is not mentioned in the provided context. The context appears to be related to PT Perkebunan Nusantara III (Persero), a state-owned enterprise in the plantation industry.",
                        "Here is a 5-line summary:",
                        "PT Perkebunan Nusantara III (Persero) is a state-owned enterprise.",
                        "The company operates in the plantation industry.",
                        "The company's Board of Commissioners and Board of Directors are responsible for its management.",
                        "The company prioritizes good corporate governance principles.",
                        "The company's annual report provides information on its performance and activities."
                    ]
                },
                "timestamp": "2025-01-07T13:52:39.587149"
            },
            {
                "response": {
                    "query": "Tell me about PTPN company in 7 lines",
                    "response": [
                        "Here are 7 lines about PTPN company:",
                        "PT Perkebunan Nusantara III (Persero) is a state-owned plantation company in Indonesia.",
                        "The company operates in the plantation industry, with a focus on palm oil, sugar, rubber, and tea.",
                        "PTPN III has a total planted area of 559,577.36 ha, with palm oil covering the largest area.",
                        "The company's financial performance in 2023 was affected by global and national economic conditions.",
                        "PTPN III has implemented various strategic initiatives to improve its performance, including digitalization and technology adoption.",
                        "The company is committed to sustainable business practices and has implemented environmental and social responsibility programs.",
                        "PTPN III aims to become a world-class competitive national agribusiness company, contributing to national advancement and sustainable growth."
                    ]
                },
                "timestamp": "2025-01-07T13:53:41.174985"
            }
        ]
    }
}